import axios from "axios";
import { API_CONST } from "../const";

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("authToken")}`,
});

export const fetchPartnerOrganizations = async () => {
  try {
    const response = await axios.get(API_CONST.GET_PARTNER_ORGANIZATIONS, {
      headers: getAuthHeaders(),
    });
    return response.data.organizations || [];
  } catch (error) {
    console.error("Error fetching partner organizations:", error);
    return [];
  }
};

export const fetchCustomerOrganizations = async () => {
  try {
    const response = await axios.get(API_CONST.GET_CUSTOMER_ORGANIZATIONS, {
      headers: getAuthHeaders(),
    });
    return response.data.organizations || [];
  } catch (error) {
    console.error("Error fetching customer organizations:", error);
    return [];
  }
};

export const fetchTalentProfiles = async (filters = {}) => {
  try {
    const response = await axios.post(API_CONST.GET_TALENT_PROFILES, filters, {
      headers: getAuthHeaders(),
    });
    return response.data.Response || [];
  } catch (error) {
    console.error("Error fetching talent profiles:", error);
    return [];
  }
};

export const fetchJobRequirements = async (filters = {}) => {
  try {
    const response = await axios.post(API_CONST.GET_JOB_REQUIREMENTS, filters, {
      headers: getAuthHeaders(),
    });
    return response.data.Response || [];
  } catch (error) {
    console.error("Error fetching job requirements:", error);
    return [];
  }
};

export const fetchTalentJobApplications = async (talentId) => {
  try {
    const response = await axios.post(
      API_CONST.GET_TALENT_JOB_APPLICATIONS,
      { talentId },
      { headers: getAuthHeaders() }
    );
    return response.data.Response || [];
  } catch (error) {
    console.error("Error fetching talent job applications:", error);
    return [];
  }
};

export const formatDropdownOptions = (data, valueField, labelField, labelFormatter = null) => {
  return data.map((item) => ({
    value: item[valueField],
    label: labelFormatter ? labelFormatter(item) : item[labelField],
    ...item,
  }));
};
